module.exports = __webpack_public_path__ + "static/media/paragon_mission_banner.9e9885cb.jpg";